{
  "title": "What's on your mind?",
  "imageGridCards": {
    "info": [
      {
        "id": "750592",
        "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83649?collection_id=83649&searchQuery=biryani&tags=layout_CCS_Biryani&type=rcv2",
          "text": "Biryani",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for biryani",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&searchQuery=biryani",
        "frequencyCapping": {}
      },
      {
        "id": "750584",
        "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83646?collection_id=83646&tags=layout_CCS_SouthIndian&type=rcv2",
          "text": "South Indian",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for south indian",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian",
        "frequencyCapping": {}
      },
      {
        "id": "750572",
        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2",
          "text": "Pure Veg",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for veg",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg",
        "frequencyCapping": {}
      },
      {
        "id": "750580",
        "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83644?collection_id=83644&tags=layout_CCS_Pizza&type=rcv2",
          "text": "pizzas",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for pizza",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza",
        "frequencyCapping": {}
      },
      {
        "id": "749874",
        "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
          "text": "Cakes",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for cakes",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
        "frequencyCapping": {}
      },
      {
        "id": "750597",
        "imageId": "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
          "text": "Ice Cream",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for icecream",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
        "frequencyCapping": {}
      },
      {
        "id": "750205",
        "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Parotta.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80478?collection_id=80478&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
          "text": "Parotta",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for parotta",
          "altTextCta": "open"
        },
        "entityId": "80478",
        "frequencyCapping": {}
      },
      {
        "id": "762797",
        "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83637?collection_id=83637&tags=layout_CCS_Burger&type=rcv2",
          "text": "Burgers",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for burger",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger",
        "frequencyCapping": {}
      },
      {
        "id": "750223",
        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
          "text": "Rolls",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for roll",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
        "frequencyCapping": {}
      },
      {
        "id": "750132",
        "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2",
          "text": "Dosa",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for dosa",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa",
        "frequencyCapping": {}
      },
      {
        "id": "750588",
        "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
          "text": "Chinese",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for chinese",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
        "frequencyCapping": {}
      },
      {
        "id": "750239",
        "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
          "text": "Shake",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for shakes",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
        "frequencyCapping": {}
      },
      {
        "id": "750582",
        "imageId": "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
        "action": {
          "link": "https://www.swiggy.com/collections/83645?collection_id=83645&tags=layout_CCS_NorthIndian&type=rcv2",
          "text": "North Indian",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for north indian",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian",
        "frequencyCapping": {}
      },
      {
        "id": "750207",
        "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
          "text": "Pasta",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for pasta",
          "altTextCta": "open"
        },
        "entityId": "80480",
        "frequencyCapping": {}
      },
      {
        "id": "750562",
        "imageId": "v1674029842/PC_Creative%20refresh/3D_bau/banners_new/Vada.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80427?collection_id=80427&tags=layout_BAU_Contextual%2Cvada&type=rcv2",
          "text": "Vada",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for vada",
          "altTextCta": "open"
        },
        "entityId": "80427",
        "frequencyCapping": {}
      },
      {
        "id": "750249",
        "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80403?collection_id=80403&tags=layout_Shawarma_Contextual&type=rcv2",
          "text": "Shawarma",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for shawarma",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=80403&tags=layout_Shawarma_Contextual",
        "frequencyCapping": {}
      },
      {
        "id": "750237",
        "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Poori.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80378?collection_id=80378&tags=layout_BAU_Contextual%2Cpoori&type=rcv2",
          "text": "Poori",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for poori",
          "altTextCta": "open"
        },
        "entityId": "80378",
        "frequencyCapping": {}
      },
      {
        "id": "750636",
        "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
          "text": "Kebabs",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurant curated for kebabs",
          "altTextCta": "open"
        },
        "entityId": "80452",
        "frequencyCapping": {}
      },
      {
        "id": "750644",
        "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80441?collection_id=80441&searchContext=idli&tags=layout_CCS_Idli&type=rcv2",
          "text": "Idli",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for idly",
          "altTextCta": "open"
        },
        "entityId": "swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli&searchContext=idli",
        "frequencyCapping": {}
      },
      {
        "id": "750203",
        "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
        "action": {
          "link": "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
          "text": "Paratha",
          "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
          "altText": "restaurants curated for paratha",
          "altTextCta": "open"
        },
        "entityId": "80476",
        "frequencyCapping": {}
      }
    ]
  }
}
